import { api } from './api-client';
import type {
  PaymentRemindersPreview,
  PaymentReminderScope,
  SendPaymentRemindersResponse,
} from '@residenone/shared';

export type { PaymentRemindersPreview };

export async function getRemindersPreview(scope: PaymentReminderScope): Promise<PaymentRemindersPreview> {
  const { data } = await api.get<PaymentRemindersPreview>('/admin/reminders/preview', { params: { scope } });
  return data;
}

export async function sendPaymentReminders(scope: PaymentReminderScope, message: string): Promise<SendPaymentRemindersResponse> {
  const { data } = await api.post<SendPaymentRemindersResponse>('/admin/reminders', { scope, message });
  return data;
}
